import { endOfDay, getTime, startOfDay } from 'date-fns';

const DEFAULT_ORDER_SORT = {
  order: [{ by: 'id', order: 'desc' }],
};

export const FAILED_ORDER_STATUSES = [354, 355, 356];

/** Matches backend CANCELLATION_REASON labels (filter API values). */
export const ORDER_CANCELLATION_REASON_OPTIONS = [
  'Mokėjimas negautas',
  'Įrenginio aktyvacija nepavyko',
  'Nėra savitarnos rezultato',
];

/** "Visi" checks every option — treat like no filter; do not send to API. */
export const shouldSubmitCancellationReasonFilter = selected =>
  selected.length > 0 &&
  !ORDER_CANCELLATION_REASON_OPTIONS.every(reason => selected.includes(reason));

export const isFailedOrderStatus = status =>
  FAILED_ORDER_STATUSES.includes(Number(status));

const createLocalDay = date => {
  if (!date || typeof date !== 'string') {
    return null;
  }

  const [year, month, day] = date.split('-').map(Number);

  if (!year || !month || !day) {
    return null;
  }

  return new Date(year, month - 1, day);
};

export const buildFailedOrdersPreset = ({ date, serviceId } = {}) => {
  const day = createLocalDay(date);

  if (!day) {
    return null;
  }

  const createdAtGtFilter = getTime(startOfDay(day));
  const createdAtLtFilter = getTime(endOfDay(day));
  const servicesFilter = serviceId ? [Number(serviceId)] : [];
  const generatedFilter = [
    { field: 'status', value: FAILED_ORDER_STATUSES },
    {
      field: 'created_at',
      expression: 'gte',
      value: createdAtGtFilter,
      type: 'timestamp',
    },
    {
      field: 'created_at',
      expression: 'lte',
      value: createdAtLtFilter,
      type: 'timestamp',
    },
  ];

  if (servicesFilter.length && !Number.isNaN(servicesFilter[0])) {
    generatedFilter.push({
      field: 'service_types',
      value: servicesFilter,
      convert: 'smallint',
      expression: 'overlap',
    });
  }

  return {
    filterBody: {
      ...DEFAULT_ORDER_SORT,
      filter: {
        and: generatedFilter,
      },
    },
    statusFilter: FAILED_ORDER_STATUSES,
    servicesFilter,
    createdAtGtFilter,
    createdAtLtFilter,
    sortOrder: 'desc',
  };
};

export const getOrderFailureReason = order =>
  order && order.cancellation_reason ? order.cancellation_reason : '-';

export const getOrderErrorMessage = getOrderFailureReason;
